enum BookingSubStatusEnum {
    None = 0,
    WaitingForReview = 1,
    ConfirmedByStaff = 2,
    ProposeChanges = 3,
    ProposalTimeout = 4,
    AcceptedByGuest = 5,
    RejectedByGuest = 6,
    RejectedByStaff = 7,
}
export default BookingSubStatusEnum;
